import OrderStatus from './OrderStatus';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import upperFirst from 'lodash/upperFirst';
import withGlobalContent from '../../../hocs/withGlobalContent';

const enhance = compose(
  withGlobalContent,
  withProps(({ globalContent: { orders }, status }) => {
    const { label = upperFirst(status) } = orders.states.find(({ state }) => state === status) || {};
    return {
      title: label
    };
  })
);

export default enhance(OrderStatus);



// WEBPACK FOOTER //
// ./src/client/js/view/components/Order/OrderStatus/index.js